import { render, staticRenderFns } from "./AcceptedCompaniesTab.vue?vue&type=template&id=308933e1&scoped=true&"
import script from "./AcceptedCompaniesTab.vue?vue&type=script&lang=js&"
export * from "./AcceptedCompaniesTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308933e1",
  null
  
)

export default component.exports